module.exports = __webpack_public_path__ + "img/vipGMProp.9dd7cab7.png";